import { LogLevel, log } from "../utils/log";
import { GameEvent } from "../interfaces/theos.interface";
import type { IPostMessageApi } from "../interfaces/postMessageApi.interface";
import { postToOperator } from "./postToOperator";

interface OutboundMessage {
    readonly type: GameEvent;
    readonly payload?: unknown;
}

type MessageEventHandler = (event: MessageEvent) => void;

const outboundMessageBuffer: OutboundMessage[] = [];
const inboundMessageBuffer: {event: MessageEvent; handler: MessageEventHandler}[] = [];

const MAX_BUFFER_SIZE = 32;

export const pushToOutboundMessageBuffer = (event: GameEvent, payload: unknown): void =>
{
    if (event === GameEvent.GAME_LOAD_PROGRESS || outboundMessageBuffer.length >= MAX_BUFFER_SIZE) {
        return;
    }

    outboundMessageBuffer.push({type: event, payload});
};

export const pushToInboundMessageBuffer = (event: MessageEvent, handler: MessageEventHandler): void =>
{
    inboundMessageBuffer.push({event, handler});
};

export const flushOutboundMessageBuffer = (api: IPostMessageApi): void =>
{
    outboundMessageBuffer.forEach((pendingMessage) => {
        log("Deferred send 🠊", LogLevel.ALL_MESSAGES, pendingMessage);
        postToOperator(api.processOutbound(pendingMessage.type, pendingMessage.payload));
    });

    outboundMessageBuffer.length = 0;
};

export const processInboundMessageBuffer = (): void =>
{
    inboundMessageBuffer.forEach((element) => {
        const {event, handler} = element;
        handler(event);
    });

    inboundMessageBuffer.length = 0;
};